import Link from "@mui/material/Link";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games and get 10% off, add 4 games and get 20% off, or add 6 games and get 30% off your seats!",
  progressBarAditionalText: " to continue for 20% off your seats!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games ",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com ",
    description:
      "Click Continue and connect your Tulsa Drillers account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=TLDM_MYTIXX&orgid=57370&_wcsid=CB8671B60651CF3ABB0A1A901E469B8584DAE2E28BA19C3DD2A4146F44E9B90D#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DTLDM_MYTIXX%26orgid%3D57370"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Drillers Pick'em Pack work?",
    description:
      "The Drillers Pick'em Pack allows fans to select any seat to select games hosted by Tulsa Drillers. Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Tulsa Drillers{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=TLDM_MYTIXX&orgid=57370&_wcsid=CB8671B60651CF3ABB0A1A901E469B8584DAE2E28BA19C3DD2A4146F44E9B90D#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DTLDM_MYTIXX%26orgid%3D57370"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        Account.
      </>
    ),
  },
];
